import {Ng1Controller, Transition, TargetState, StateService} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {IHttpService, IScope} from "angular";
import {SpinnerService} from "../../modules/SpinnerModule";
import {IntuitPartnerPaymentImportDto} from "../../model/IntuitPartnerPaymentImportDto";
import {ConfigService} from "../../modules/ConfigModule";
import {ngStorage} from "ngstorage";
import StorageService = ngStorage.StorageService;
import {IntuitPartnerPaymentLineDto} from "../../model/IntuitPartnerPaymentLineDto";

export default class IntuitPartnerPaymentController implements Ng1Controller {
    private error: any;
    private model: IntuitPartnerPaymentImportDto;
    private fileInput: HTMLInputElement;

    $onInit(): void {
        this.refresh();
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }

    constructor(private $dataHub: DataHubService,
                private $scope: IScope,
                private $http: IHttpService,
                private $spinner: SpinnerService,
                private $sessionStorage: StorageService,
                private $config: ConfigService,
                private $state: StateService,
                private $stateParams: any) {
        $dataHub.onConnected(this.refresh);

        this.model = $sessionStorage.intuitPartnerPaymentImport;
        if (!this.model) {
            this.reset();
        }
    }

    reset = () => {
        this.$http.post<IntuitPartnerPaymentImportDto>(this.$config.apiBase + 'import/intuitPartnerPayment/prepare', null)
            .then(r => {
                this.$sessionStorage.intuitPartnerPaymentImport = r.data;
                this.model = this.$sessionStorage.intuitPartnerPaymentImport;
            });
        if (this.fileInput)
            this.fileInput[0].value = "";
    };

    refresh = () => {
        if (!this.$dataHub.isConnected) return;
        // load data or something
    };

    fileSelect = () => {
        var input = this.fileInput[0];
        input.onchange = this.fileInputChanged;
        input.click();
    };

    fileInputChanged = () => {
        console.debug(this.fileInput);
        const file = this.fileInput[0].files[0];
        if (!file.name.toLowerCase().endsWith('csv')) {
            alert('Please select a CSV file');
            return;
        }

        const reader = new FileReader();
        reader.onload = value => {
            this.$scope.$apply(() => {

                this.$spinner.show('Checking CSV');
                this.$http.post<string[]>(this.$config.apiBase + 'import/csvHeaders', {fileData: reader.result})
                    .then(r => {
                        this.model.fileName = file.name;
                        this.model.fileData = reader.result.toString();
                        this.model.headers = r.data;
                    })
                    .catch(e => {
                        console.error(e);
                        this.reset();
                        window.alert(e.data.exceptionMessage);
                    })
                    .finally(() => this.$spinner.hide());
            });
        };
        reader.readAsDataURL(file);

    };

    prepare = () => {
        this.$spinner.show('Preparing');
        this.$http.post<IntuitPartnerPaymentImportDto>(this.$config.apiBase + 'import/intuitPartnerPayment/prepare', this.model)
            .then(r => {
                this.$sessionStorage.intuitPartnerPaymentImport = r.data;
                this.model = this.$sessionStorage.intuitPartnerPaymentImport;
            })
            .catch(e => alert(e))
            .finally(() => this.$spinner.hide());
    };

    import = () => {
        this.$spinner.show('Importing');
        this.$http.post<IntuitPartnerPaymentImportDto>(this.$config.apiBase + 'import/intuitPartnerPayment/process', this.model)
            .then(r => {
                this.reset();
            })
            .catch(e => alert(e))
            .finally(() => this.$spinner.hide());
    }

    applyCustomerToAllSecondary = (row: IntuitPartnerPaymentLineDto) => {
        this.model.lines.forEach(line => {
            if (line.secondaryName == row.secondaryName)
                line.customer = row.customer;
        });
    }

    applyCustomerToAllCustomer = (row: IntuitPartnerPaymentLineDto) => {
        this.model.lines.forEach(line => {
            if (line.customerName == row.customerName)
                line.customer = row.customer;
        });
    }
}
